import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import FormError from '../Forms/FormError';
import Button from '../Button';
import SecondaryButton from '../SecondaryButton';
import styles from './ExtraUserInformation.css';

const ExtraUserInformationForm = ({
    handleSubmit,
    error,
    children,
    pristine,
    valid,
    saveButton,
    closeButton,
    onClose,
    submitting,
}) => (<form onSubmit={handleSubmit}>
    <FormError error={error} />
    {children}
    <div className={styles.btnWrap}>
        {closeButton ? <SecondaryButton
            onClick={onClose}
            className={styles.button}
        >
            {closeButton}
        </SecondaryButton> : null}
        <Button
            type="submit"
            loading={submitting}
            disabled={pristine || !valid}
            className={styles.button}
        >
            {saveButton}
        </Button>
    </div>
</form>);

ExtraUserInformationForm.propTypes = {
    submitting: PropTypes.bool,
    pristine: PropTypes.bool,
    valid: PropTypes.bool,
    handleSubmit: PropTypes.func,
    error: PropTypes.any,
    children: PropTypes.node,
    saveButton: PropTypes.string,
    closeButton: PropTypes.string,
    onClose: PropTypes.func,
};

const formKey = 'extra-user-form';

export default reduxForm({
    form: formKey,
    destroyOnUnmount: false,
})(ExtraUserInformationForm);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/ExtraUserInformationForm.js